import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xl};
`;

const Section = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => `${theme.spacing.lg} 0`};
  font-size: 1.5rem;
`;

const Text = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  line-height: 1.6;
`;

const List = styled.ul`
  margin: ${({ theme }) => theme.spacing.md} 0;
  padding-left: ${({ theme }) => theme.spacing.xl};

  li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    line-height: 1.6;
  }
`;

const Refund = () => {
  return (
    <Container>
      <Title>Refund Policy</Title>
      
      <Section>
        <Text>Last updated: January 2024</Text>
        <Text>
          We want you to be completely satisfied with your Binventory subscription. This policy 
          outlines our refund terms and conditions.
        </Text>
      </Section>

      <Section>
        <Subtitle>1. Subscription Refunds</Subtitle>
        <Text>
          We offer a 30-day money-back guarantee on all new Premium subscriptions. If you're not 
          satisfied with our service, you can request a full refund within 30 days of your initial 
          purchase.
        </Text>
      </Section>

      <Section>
        <Subtitle>2. Eligibility</Subtitle>
        <Text>To be eligible for a refund:</Text>
        <List>
          <li>The request must be made within 30 days of the initial purchase</li>
          <li>The account must be in good standing</li>
          <li>You must not have violated our Terms of Service</li>
        </List>
      </Section>

      <Section>
        <Subtitle>3. Refund Process</Subtitle>
        <Text>To request a refund:</Text>
        <List>
          <li>Contact our support team via email or phone</li>
          <li>Provide your account email and reason for the refund</li>
          <li>Refunds are processed through your original payment method</li>
          <li>Processing time is typically 5-10 business days</li>
        </List>
      </Section>

      <Section>
        <Subtitle>4. Non-Refundable Items</Subtitle>
        <Text>The following are not eligible for refunds:</Text>
        <List>
          <li>Partial months of service</li>
          <li>Accounts that have violated our Terms of Service</li>
          <li>Subscription renewals after the initial 30-day period</li>
        </List>
      </Section>

      <Section>
        <Subtitle>5. Cancellation Policy</Subtitle>
        <Text>
          You can cancel your subscription at any time. Cancellations take effect at the end of 
          your current billing period. No partial refunds are provided for unused portions of a 
          billing period.
        </Text>
      </Section>

      <Section>
        <Subtitle>6. Contact Information</Subtitle>
        <Text>
          For refund requests or questions about this policy, please contact us:
        </Text>
        <Text>
          Email: billing@binventory.com<br />
          Phone: (555) 123-4567<br />
          Address: 123 Inventory Lane, Suite 100, San Francisco, CA 94105
        </Text>
      </Section>
    </Container>
  );
};

export default Refund; 